<nav class="navbar navbar-expand-lg fixed-top custom-navbar">
  <div class="container-fluid navbar-inner">

    <!-- MARCA -->
    <a class="navbar-brand brand-link" routerLink="/home" (click)="closeMobileMenu()">
      <img
        src="abaq.png"
        alt="Logo ABAQ"
        class="brand-logo"
      />

      <div class="brand-text">
        <span class="brand-main">ABAQ</span>
        <span class="brand-subtitle">Servicio Social</span>
      </div>
    </a>

    <!-- ACCIONES RÁPIDAS EN MÓVIL Y TABLET -->
    <div class="mobile-top-actions">
      <!-- TOGGLER HAMBURGUESA -->
      <button
        class="navbar-toggler"
        [class.is-open]="isMobileMenuOpen"
        type="button"
        (click)="toggleMobileMenu($event)"
        aria-controls="navbarCollapse"
        [attr.aria-expanded]="isMobileMenuOpen"
        [attr.aria-label]="isMobileMenuOpen ? 'Cerrar menú de navegación' : 'Abrir menú de navegación'"
      >
        @if (!isMobileMenuOpen) {
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ffffff"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        } @else {
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ffffff"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        }
      </button>
    </div>

    <!-- ZONA CENTRAL + SESIÓN -->
    <div
      class="collapse navbar-collapse navbar-content"
      [class.show]="isMobileMenuOpen"
      id="navbarCollapse"
    >

      <!-- MENÚ -->
      <ul class="navbar-nav navbar-menu">

        @if (user$ | async; as user) {

          @if (user.role === 'admin') {

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/admin/home"
                routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="closeMobileMenu()"
              >
                Inicio
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/student"
                routerLinkActive="active-link"
                (click)="closeMobileMenu()"
              >
                Voluntarios
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/activity-list"
                routerLinkActive="active-link"
                (click)="closeMobileMenu()"
              >
                Actividades
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/admin/quick-activities"
                routerLinkActive="active-link"
                (click)="closeMobileMenu()"
              >
                Nueva Actividad
              </a>
            </li>

            <li class="nav-item dropdown" [class.show]="isAdminDropdownOpen">

              <a
                class="nav-link dropdown-toggle"
                [class.active-link]="isServicioSocialActive()"
                href="#"
                role="button"
                (click)="toggleAdminDropdown($event)"
                [attr.aria-expanded]="isAdminDropdownOpen"
              >
                <span>Servicio Social</span>
                <span
                  class="material-symbols-outlined nav-dropdown-icon"
                  [class.rotated]="isAdminDropdownOpen"
                >
                  keyboard_arrow_down
                </span>
              </a>

              <ul class="dropdown-menu" [class.show]="isAdminDropdownOpen">

                <li>
                  <a
                    class="dropdown-item"
                    routerLink="/admin/talks"
                    routerLinkActive="active-dropdown-item"
                    (click)="closeMobileMenu()"
                  >
                    Pláticas
                  </a>
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    routerLink="/admin/campaigns"
                    routerLinkActive="active-dropdown-item"
                    (click)="closeMobileMenu()"
                  >
                    Campañas EST
                  </a>
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    routerLink="/admin/adoptions"
                    routerLinkActive="active-dropdown-item"
                    (click)="closeMobileMenu()"
                  >
                    Adopciones
                  </a>
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    routerLink="/admin/identifications"
                    routerLinkActive="active-dropdown-item"
                    (click)="closeMobileMenu()"
                  >
                    Placas de identificación
                  </a>
                </li>

              </ul>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/admin/accreditations"
                routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="closeMobileMenu()"
              >
                Acreditaciones
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/admin/backups"
                routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="closeMobileMenu()"
              >
                Respaldos
              </a>
            </li>

          }

          @if (user.role === 'student') {

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/home"
                routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="closeMobileMenu()"
              >
                Inicio
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/activity-list"
                routerLinkActive="active-link"
                (click)="closeMobileMenu()"
              >
                Actividades
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/student-profile"
                routerLinkActive="active-link"
                (click)="closeMobileMenu()"
              >
                Mi perfil
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/my-accreditations"
                routerLinkActive="active-link"
                (click)="closeMobileMenu()"
              >
                Mis Acreditaciones
              </a>
            </li>

          }

          @if (user.role === 'volunteer') {

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/volunteer-home"
                routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="closeMobileMenu()"
              >
                Inicio
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/activity-list"
                routerLinkActive="active-link"
                (click)="closeMobileMenu()"
              >
                Actividades
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/volunteer-profile"
                routerLinkActive="active-link"
                (click)="closeMobileMenu()"
              >
                Mi perfil
              </a>
            </li>

          }

        }

      </ul>

      <!-- SESIÓN -->
      <div class="navbar-session">

        @if (user$ | async; as user) {
          <a
            class="nav-link logout-link"
            href="#"
            (click)="logout(); $event.preventDefault()"
          >
            Cerrar sesión
          </a>
        } @else if (!isPublicFormPage()) {
          <a
            class="nav-link login-link"
            routerLink="/auth/login"
            (click)="closeMobileMenu()"
          >
            Iniciar sesión
          </a>
        }

      </div>

    </div>

  </div>
</nav>